/* tslint:disable */
/* eslint-disable */
export enum AccessType {
  Batch = 'BATCH',
  IcWeb = 'IC_WEB',
  AdminWeb = 'ADMIN_WEB',
  HospiWeb = 'HOSPI_WEB',
  ReportWeb = 'REPORT_WEB',
  Kiosk = 'KIOSK',
  Home = 'HOME',
  S4 = 'S4',
  ZetesSoap = 'ZETES_SOAP',
  IcSoap = 'IC_SOAP',
  HospiSoap = 'HOSPI_SOAP',
  AtaoAdminWeb = 'ATAO_ADMIN_WEB',
  AtaoIcWeb = 'ATAO_IC_WEB',
  AtaoHospiWeb = 'ATAO_HOSPI_WEB',
  AtaoReportWeb = 'ATAO_REPORT_WEB',
  KineWebServices = 'KINE_WEB_SERVICES',
  AttachementsViewer = 'ATTACHEMENTS_VIEWER'
}
